import React, { FC } from 'react';
import { Alert, Card, CardBody, Col, Row } from 'reactstrap';
import { HotelPublicInformation, ReleaseGroupType } from '../../../shared/hotel';
import { CardList, MessageCard, TermsLoaderWrapper } from '../../components';
import { useTranslation } from '../../translations';
import { useConvention } from '../../utils';
import { FCFSListItem } from './wavelist/FCFSListItem';
import { RandomListItem } from './wavelist/RandomListItem';

interface WaveListProps {
  readonly info: HotelPublicInformation;
}

export const WaveList: FC<WaveListProps> = ({ info }) => {
  const convention = useConvention();
  const { ts } = useTranslation();

  if (!convention.hotelsOpen) {
    return (
      <div className="hotel-dashboard-closed" id="hotelReservationsClosed">
        <MessageCard
          icon="remove_circle"
          id="hotelsClosed"
          level="danger"
          title={ts('hotel.booking_closed', convention.longName)}
        >
          <p>{ts('hotel.booking_closed.explanation')}</p>
          <TermsLoaderWrapper hideEmpty name="hotelClosedError">
            {(terms) => (
              <Alert className="mt-3" color="info" fade={false}>
                {terms}
              </Alert>
            )}
          </TermsLoaderWrapper>
        </MessageCard>
      </div>
    );
  }

  return (
    <div className="hotel-dashboard-wave-info">
      <CardList listName="hotel-waves" showCount title={ts('hotel.active_waves')}>
        {info.releaseGroups.map((wave) =>
          wave.type === ReleaseGroupType.FirstComeFirstServe ? (
            <FCFSListItem key={wave.id} wave={wave} />
          ) : (
            <RandomListItem key={wave.id} wave={wave} />
          ),
        )}
      </CardList>
      {info.releaseGroups.length === 0 && (
        <Row>
          <Col md={6} xs={12}>
            <Card className="mt-2" id="noReleases">
              <CardBody>
                <h4>{ts('no_releases_available')}</h4>
                <hr className="mb-3" />
                <p>{ts('there_are_currently_no_hotel_releases_available_to_enter_at_this_time')}</p>
                <p className="mb-0">{ts('please_check_back_later_for_more_information')}</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
};
